/* ============================================================
   LUXEA — Creador de Packs
   - Pack de 3 (−15%) o pack de 5 (−20%)
   - Por cada slot: elige perfume (tarjetas con foto) + color
   - Calcula el precio original tachado y el precio con descuento
   - Añade todo al carrito y aplica el código de descuento automáticamente
   - Extra opcional: decant vacío con jeringuilla, con su propio color, sin descuento
   ============================================================ */
(function () {
  'use strict';

  const root = document.querySelector('[data-pack-builder]');
  if (!root) return;

  const config = JSON.parse(root.getAttribute('data-config') || '{}');
  const products = window.LuxeaPackProducts || [];
  const colors = window.LuxeaColors || [];
  const extraProduct = window.LuxeaPackExtra || null;

  const slotsContainer = root.querySelector('[data-pack-slots]');
  const tabs = root.querySelectorAll('[data-pack-tab]');
  const addBtn = root.querySelector('[data-pack-add]');
  const elOriginal = root.querySelector('[data-pack-original]');
  const elFinal = root.querySelector('[data-pack-final]');
  const elSave = root.querySelector('[data-pack-save]');

  const extraToggle = root.querySelector('[data-pack-extra-toggle]');
  const extraColorField = root.querySelector('[data-pack-extra-color-field]');
  const extraColorsContainer = root.querySelector('[data-pack-extra-colors]');
  const extraPreview = root.querySelector('[data-pack-extra-preview]');

  const money = (window.Luxea && window.Luxea.money) || ((c) => (c / 100).toFixed(2) + ' €');

  let state = {
    size: parseInt(config.defaultSize || 3, 10),
    selections: []
  };
  let extraSelected = false;
  let extraColorHandle = '';

  const discountFor = (size) => size >= 5 ? (config.discount5 || 20) : (config.discount3 || 15);
  const codeFor = (size) => size >= 5 ? (config.code5 || 'PACK5') : (config.code3 || 'PACK3');

  function productById(id) { return products.find((p) => String(p.id) === String(id)); }

  function firstImageFor(p) {
    if (!p) return '';
    if (p.images) {
      const firstKey = Object.keys(p.images)[0];
      if (firstKey) return p.images[firstKey];
    }
    return p.image || '';
  }

  function buildSlot(index) {
    const slot = document.createElement('div');
    slot.className = 'pack-slot';
    slot.setAttribute('data-slot', index);

    const groups = {};
    products.forEach((p) => { (groups[p.gender] = groups[p.gender] || []).push(p); });
    const labels = { hombre: 'Hombre', mujer: 'Mujer', otros: 'Otros' };

    let picker = '<div class="pack-picker" data-pack-picker>';
    Object.keys(groups).forEach((g) => {
      picker += '<div class="pack-picker__group-label">' + (labels[g] || g) + '</div>';
      picker += '<div class="pack-picker__grid">';
      groups[g].forEach((p) => {
        const img = firstImageFor(p);
        picker += '<button type="button" class="pack-picker__item" data-pack-perfume-item data-product-id="' + p.id + '">' +
          '<div class="pack-picker__img">' + (img ? '<img src="' + img + '" alt="' + p.title + '">' : '') + '</div>' +
          '<div class="pack-picker__name">' + p.title + '</div>' +
        '</button>';
      });
      picker += '</div>';
    });
    picker += '</div>';

    const swatches = colors.map((c) =>
      '<button type="button" class="swatch" data-pack-color="' + c.handle + '" title="' + c.name + '" style="background:' + c.hex + '"></button>'
    ).join('');

    slot.innerHTML =
      '<div class="pack-slot__num">' + (index + 1) + '</div>' +
      '<div class="pack-slot__field">' +
        '<label>Perfume</label>' +
        '<div class="pack-slot__selected" data-pack-selected><span data-pack-selected-text>— Elige un perfume —</span><span class="pack-slot__arrow">▾</span></div>' +
        picker +
      '</div>' +
      '<div class="pack-slot__field" data-pack-color-field style="display:none">' +
        '<label>Color del atomizador</label>' +
        '<div class="pack-slot__colors" data-pack-colors>' + swatches + '</div>' +
      '</div>' +
      '<div class="pack-slot__preview" data-pack-preview style="display:none"></div>';
    return slot;
  }

  function renderSlots() {
    slotsContainer.innerHTML = '';
    state.selections = [];
    for (let i = 0; i < state.size; i++) {
      state.selections.push({ productId: '', colorHandle: '' });
      slotsContainer.appendChild(buildSlot(i));
    }
    updateSummary();
  }

    function updateSummary() {
    let original = 0;
    let allComplete = true;
    let missingMsg = '';
    state.selections.forEach((sel, i) => {
      const p = productById(sel.productId);
      if (p && sel.colorHandle) { original += p.price; }
      else {
        allComplete = false;
        if (!missingMsg) {
          missingMsg = p
            ? 'Falta elegir el color del perfume ' + (i + 1)
            : 'Falta elegir el perfume ' + (i + 1);
        }
      }
    });
    const rate = discountFor(state.size);
    let final = 0;
    state.selections.forEach((sel) => {
      const p = productById(sel.productId);
      if (p && sel.colorHandle) final += p.price - Math.round(p.price * rate / 100);
    });
    const saved = original - final;

    if (elOriginal) elOriginal.textContent = money(original);
    if (elFinal) elFinal.textContent = money(final);
    if (elSave) elSave.textContent = '−' + rate + '% · Ahorras ' + money(saved);
    if (addBtn) {
      addBtn.disabled = !allComplete;
      addBtn.textContent = allComplete ? 'Añadir pack al carrito' : missingMsg;
    }
  }
  
  slotsContainer.addEventListener('click', (e) => {
    const item = e.target.closest('[data-pack-perfume-item]');
    if (item) {
      const slotEl = item.closest('[data-slot]');
      const idx = parseInt(slotEl.getAttribute('data-slot'), 10);
      const productId = item.getAttribute('data-product-id');
      state.selections[idx].productId = productId;
      state.selections[idx].colorHandle = '';

      slotEl.querySelectorAll('[data-pack-perfume-item]').forEach((el) => el.classList.remove('is-active'));
      item.classList.add('is-active');

      const p = productById(productId);
      const selectedText = slotEl.querySelector('[data-pack-selected-text]');
      if (selectedText) selectedText.textContent = p ? p.title : '— Elige un perfume —';
      const picker = slotEl.querySelector('[data-pack-picker]');
      if (picker) picker.classList.remove('is-open');

      const colorField = slotEl.querySelector('[data-pack-color-field]');
      if (colorField) colorField.style.display = '';

      updatePreview(slotEl, idx);
      updateSummary();
      return;
    }

    const selectedBox = e.target.closest('[data-pack-selected]');
    if (selectedBox) {
      const slotEl = selectedBox.closest('[data-slot]');
      const picker = slotEl.querySelector('[data-pack-picker]');
      slotsContainer.querySelectorAll('[data-pack-picker].is-open').forEach((p) => {
        if (p !== picker) p.classList.remove('is-open');
      });
      if (picker) picker.classList.toggle('is-open');
      return;
    }

    const sw = e.target.closest('[data-pack-color]');
    if (sw) {
      const slotEl = sw.closest('[data-slot]');
      const idx = parseInt(slotEl.getAttribute('data-slot'), 10);
      slotEl.querySelectorAll('[data-pack-color]').forEach((s) => s.classList.remove('is-active'));
      sw.classList.add('is-active');
      state.selections[idx].colorHandle = sw.getAttribute('data-pack-color');
      updatePreview(slotEl, idx);
      updateSummary();
      return;
    }
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.pack-slot__field')) {
      slotsContainer.querySelectorAll('[data-pack-picker].is-open').forEach((p) => p.classList.remove('is-open'));
    }
  });

  function updatePreview(slotEl, idx) {
    const sel = state.selections[idx];
    const preview = slotEl.querySelector('[data-pack-preview]');
    const p = productById(sel.productId);

    if (!p) {
      preview.style.display = 'none';
      preview.innerHTML = '';
      return;
    }

    const colorHandle = sel.colorHandle || (colors[0] && colors[0].handle);
    let img = (p.images && p.images[colorHandle]) || firstImageFor(p);
    if (img) {
      preview.style.display = 'flex';
      preview.innerHTML = '<img src="' + img + '" alt="' + p.title + '">';
    }
  }

  if (extraProduct && extraColorsContainer) {
    extraColorsContainer.innerHTML = colors.map((c) =>
      '<button type="button" class="swatch" data-pack-extra-color="' + c.handle + '" title="' + c.name + '" style="background:' + c.hex + '"></button>'
    ).join('');

    if (extraProduct.images) {
      Object.keys(extraProduct.images).forEach(function (colorHandle) {
        var img = new Image();
        img.src = extraProduct.images[colorHandle];
      });
    }
  }

  if (extraToggle) {
    extraToggle.addEventListener('change', () => {
      extraSelected = extraToggle.checked;
      if (extraColorField) extraColorField.style.display = extraSelected ? '' : 'none';
      if (!extraSelected) {
        extraColorHandle = '';
        if (extraColorsContainer) extraColorsContainer.querySelectorAll('[data-pack-extra-color]').forEach((s) => s.classList.remove('is-active'));
      }
      updateSummary();
    });
  }

  if (extraColorsContainer) {
    extraColorsContainer.addEventListener('click', (e) => {
      const sw = e.target.closest('[data-pack-extra-color]');
      if (!sw || !extraProduct) return;
      extraColorHandle = sw.getAttribute('data-pack-extra-color');
      extraColorsContainer.querySelectorAll('[data-pack-extra-color]').forEach((s) => s.classList.remove('is-active'));
      sw.classList.add('is-active');
      const img = (extraProduct.images && extraProduct.images[extraColorHandle]) || firstImageFor(extraProduct);
      if (extraPreview && img) {
        extraPreview.innerHTML = '<img src="' + img + '" alt="' + extraProduct.title + '">';
      }
      updateSummary();
    });
  }

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      tabs.forEach((t) => t.classList.remove('is-active'));
      tab.classList.add('is-active');
      state.size = parseInt(tab.getAttribute('data-pack-tab'), 10);
      renderSlots();
    });
  });

  if (addBtn) {
    addBtn.addEventListener('click', async () => {
      const rate = discountFor(state.size);
      const code = codeFor(state.size);
      const packLabel = 'Pack de ' + state.size + ' (−' + rate + '%)';
      const items = [];
      let ok = true;
      state.selections.forEach((sel) => {
        const p = productById(sel.productId);
        if (!p || !sel.colorHandle) { ok = false; return; }
        let variantId = p.defaultVariant;
        if (p.colorVariants && p.colorVariants[sel.colorHandle]) variantId = p.colorVariants[sel.colorHandle];
        const colorName = (window.LuxeaColorMap[sel.colorHandle] || {}).name || sel.colorHandle;
        const packImg = (p.images && p.images[sel.colorHandle]) || firstImageFor(p);
items.push({ id: variantId, quantity: 1, properties: { 'Color': colorName, '_pack': packLabel, '_img': packImg } });
      });
      if (extraSelected && (!extraProduct || !extraColorHandle)) ok = false;
      if (!ok || !items.length) return;

      if (extraSelected && extraProduct) {
        let extraVariantId = extraProduct.defaultVariant;
        if (extraProduct.colorVariants && extraProduct.colorVariants[extraColorHandle]) extraVariantId = extraProduct.colorVariants[extraColorHandle];
        const extraColorName = (window.LuxeaColorMap[extraColorHandle] || {}).name || extraColorHandle;
        const extraImg = (extraProduct.images && extraProduct.images[extraColorHandle]) || firstImageFor(extraProduct);
        items.push({ id: extraVariantId, quantity: 1, properties: { 'Color': extraColorName, '_pack_extra': 'Decant vacío con jeringuilla', '_img': extraImg } });
      }

            const original = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.innerHTML = '<span class="spinner"></span>';
      try {
        // Solo se permite un pack por pedido
        const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        const currentCart = await cartRes.json();
        const hasPack = currentCart.items.some((it) => it.properties && it.properties._pack);
        if (hasPack) {
          window.Luxea.toast('Ya tienes un pack en el carrito. Finalízalo o elimínalo antes de crear otro.');
          addBtn.disabled = false;
          addBtn.textContent = original;
          return;
        }
        await window.Luxea.Cart.add(items);
        window.location.href = '/cart';
      } catch (err) {
        window.Luxea.toast((err && err.message) || 'No se pudo crear el pack');
        addBtn.disabled = false;
        addBtn.textContent = original;
      }
    });
  }

  const defaultTab = root.querySelector('[data-pack-tab="' + state.size + '"]');
  if (defaultTab) defaultTab.classList.add('is-active');
  renderSlots();
  updateSummary();
})();